import { SelectableModel } from '../models/selectable/selectable.model';
import { SelectableStylingModel } from '../models/selectable/selectable-styling.model';

export const /** @type {?} */ SwitchTemplates = {
  defaultTemplate: {
    property: new SelectableModel({
      display: true,
      disable: false,
      value: 'slide',
      item: 'Switch Button',
      checked: true,
      itemPosition: 'after'
    }),
    style: new SelectableStylingModel({
      container: {
        class: 'cf-default-container'
      },
      button: {
        themeColor: 'primary'
      }
    })
  }
}
